/* Crave for Business v3, Shopify build. A valid form POSTs to the catering API
   (/api/business-inquiry, routed to David). The box closes and shows the
   confirmation only after a successful send; on failure the entries stay and
   #f-error shows. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Stores, grouped by state
  var sel = document.getElementById('f-store');
  Promise.resolve().then(function () { return JSON.parse(document.getElementById('cfb-stores').textContent); }).then(function (rows) {
    var groups = {};
    var order = [];
    rows.forEach(function (row) {
      var state = row[2];
      if (!groups[state]) { groups[state] = []; order.push(state); }
      groups[state].push(row);
    });
    order.forEach(function (state) {
      var og = document.createElement('optgroup');
      og.label = state;
      groups[state].forEach(function (row) {
        var o = document.createElement('option');
        o.value = row[1];
        o.textContent = row[0];
        og.appendChild(o);
      });
      sel.appendChild(og);
    });
  }).catch(function () {});

  // Form: validate, then close the box
  var form = document.getElementById('quote-form');
  var box = document.querySelector('.box');
  var seg = form.querySelector('.seg');
  var ENDPOINT = 'https://catering-api-ivory.vercel.app/api/business-inquiry';
  var sending = false;

  function mark(el, bad) {
    if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
  }

  form.addEventListener('input', function (e) {
    if (e.target.getAttribute('aria-invalid') && e.target.checkValidity()) mark(e.target, false);
    if (e.target.name === 'type') seg.classList.remove('is-invalid');
  });
  form.addEventListener('change', function (e) {
    if (e.target.tagName === 'SELECT' && e.target.checkValidity()) mark(e.target, false);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var first = null;
    Array.prototype.forEach.call(form.querySelectorAll('input:not([type=radio]), select, textarea'), function (el) {
      var bad = !el.checkValidity();
      mark(el, bad);
      if (bad && !first) first = el;
    });
    var typeOk = !!form.querySelector('input[name=type]:checked');
    seg.classList.toggle('is-invalid', !typeOk);
    if (!typeOk && !first) first = form.querySelector('input[name=type]');
    if (first) {
      first.focus();
      if (first.reportValidity) first.reportValidity();
      return;
    }
    if (sending) return;
    sending = true;
    var err = document.getElementById('f-error');
    err.hidden = true;
    var fd = new FormData(form);
    var payload = {};
    ['name', 'business', 'email', 'phone', 'store', 'type', 'count', 'date', 'notes', 'company'].forEach(function (k) {
      payload[k] = String(fd.get(k) || '');
    });
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return r.ok && j && j.success; }); })
      .catch(function () { return false; })
      .then(function (ok) {
        sending = false;
        if (ok) { closeBox(); return; }
        err.hidden = false;
      });
  });

  function closeBox() {
    var lid = box.querySelector('.box__lid');
    box.style.minHeight = box.offsetHeight + 'px';
    box.setAttribute('data-state', 'closed');
    lid.removeAttribute('aria-hidden');
    lid.setAttribute('role', 'status');
    setTimeout(function () {
      box.setAttribute('data-state', 'done');
      box.style.minHeight = '';
      box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      document.getElementById('confirm').focus({ preventScroll: true });
    }, reduce ? 0 : 950);
  }

  // Scroll reveals: tiles and pack images lift like a lid; rules draw across
  if (reduce || !('IntersectionObserver' in window)) return;
  var targets = document.querySelectorAll('.tile, .pack__img, .way, .steps');
  Array.prototype.forEach.call(document.querySelectorAll('.tile, .pack__img'), function (el) { el.classList.add('reveal'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
  Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
})();
